import styled, { css } from 'styled-components';
import IconInput from '../../assets/img/keyboard-input-cart.png';

const KeyboardContainer = styled.div`
  width: 100%;
  max-width: 330px;
  display: flex;
  flex-direction: column;
`;

const KeyboardInput = styled.input`
  margin: 5px 5px 10px 5px;
  background: url(${IconInput}) right 25px center no-repeat;
  background-size: 26px 24px;
`;

const KeyboardContent = styled.div`
  width: 100%;
  display: flex;
`;

const KeyboardNum = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
`;

const KeyboardActions = styled.div`
  width: 25%;
  display: flex;
  flex-direction: column;
`;

const KeyboarButton = styled.button`
  width: calc(33.3333% - 10px);
  height: 70px;
  margin: 5px;
  border: solid 1px ${({ theme }) => theme.palette.border.main};
  border-radius: 10px;
  font-size: 20px;
  font-weight: 600;
  transition: all ease 0.15s;
  cursor: pointer;
  background: #FFF;
  box-shadow: 0px 2px 10px -5px rgba(0, 0, 0, 0);
  font-family: 'Poppins', sans-serif;
  outline: none;
  @media (max-width: ${({ theme }) => theme.sizes.smalldesktop}px) {
    height: 60px;
  }
  &[data-value]:before {
    content: attr(data-value);
  }
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0px 2px 10px -5px rgba(0, 0, 0, 0.2);
  }
  &:active {
    transform: translateY(1px);
    box-shadow: 0px 2px 10px -5px rgba(0, 0, 0, 0);
    opacity: 0.5;
  }
  ${props =>
    props.actions &&
    css`
      background: ${({ theme }) => theme.palette.background.graylight};
      width: calc(100% - 10px);
    `}
  ${props =>
    props.enter &&
    css`
      flex: 1;
      padding-bottom: 0px;
      & > img {
        margin-bottom: -40px;
      }
    `}
`;

export {
  KeyboardContainer,
  KeyboardInput,
  KeyboardContent,
  KeyboardNum,
  KeyboardActions,
  KeyboarButton,
};
